import React from 'react';
import { List, Icon, Tooltip } from 'antd';
import UserListWrapper from './UserList.style';

const UserList = ({data,getUserReports,setUser,from}) => {

  return(
    <UserListWrapper>
      <h2>See user-wise {from} initiated by Clients</h2>
      <List
        header={<div className="flex header-user-wrapper">
                  <p className="user-name">Name</p>
                  <p className="user-email-id">Email ID</p>
                </div>}
        dataSource={data}
        renderItem={(user,i) => (<List.Item key={i+1}>
          <div className="flex user-wrapper">
            <p className="user-name">{user.name}</p>
            <p className="user-email-id">{user.email}</p>
            <div className="user-actions">
              <Tooltip  title="View Reports">
                <Icon style={{ display: from !== 'assign-reports' ? 'inline-block' : 'none' }} type="folder-open" onClick={() => getUserReports(user,from)} className="view-reports-icon" />
                <Icon style={{ display: from === 'assign-reports' ? 'inline-block' : 'none' }} type="file-pdf" onClick={() => setUser(user,from)} className="view-reports-icon" />
              </Tooltip>
            </div>
          </div>
          </List.Item>)}
        pagination={true}
      />
    </UserListWrapper>
  )
}

export default UserList;


// WEBPACK FOOTER //
// ./src/components/Box/UserList/UserList.js